<p-fieldset legend="Στοιχεία Επικοινωνίας">
    <div class="flex flex-col gap-3">
        <ng-container [formGroupName]="'Customer'">
            <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-3" style="align-self: baseline">
                    <z-float-label
                        [label]="'Όνομα'"
                        [formControlName]="'SureName'"
                    ></z-float-label>
                    <!-- <z-float-label
                    [label]="'FirstNameId'"
                    [formControlName]="'FirstNameId'"
                ></z-float-label> -->
                </div>
                <div class="flex flex-col">
                    <div formArrayName="ContactDetails">
                        <div formGroupName="0" class="flex flex-col gap-3">
                            <z-float-label
                                [label]="'Κινητό'"
                                [formControlName]="'Mobile'"
                            ></z-float-label>
                            <!-- <z-float-label
                            [label]="'Σταθερό'"
                            [formControlName]="'Phone'"
                        ></z-float-label> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-row gap-3">
                <div class="flex flex-col flex-auto">
                    <div formArrayName="ContactDetails">
                        <div formGroupName="0" class="flex flex-col">
                            <z-float-label
                                [label]="'e-Mail'"
                                [formControlName]="'EMail'"
                            ></z-float-label>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</p-fieldset>
